import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import update from 'react-addons-update';
import { Grid, Header, Table, Button, Modal } from 'semantic-ui-react';
import { CbUserModal } from 'components/Commons';
import styled from 'styled-components';
import cm from 'helpers/commons';
import storage from 'helpers/storage';
import toastr from 'helpers/toastr';

import * as usg_action from 'actions/usage';

class BillApprovalStep extends Component {
  constructor(props) {
    super(props);
    this.state = {
      render: null,
      tableHeader: null,
      tempStepList: [],
      modal: {
        open: false,
        size: 'large',
        closeFunc: this.ModalClose,
        successFunc: this.ModalAction
      },
      step: -1,
      invoicedApprovalStatus: {},
      statusFlag: null
    };
  }

  componentWillReceiveProps(nextProps) {
    const { approvalStepList } = nextProps;
    if (approvalStepList && approvalStepList.data) {
      const { approveSteps } = approvalStepList.data;
      this.setState({
        tempStepList: approveSteps
      });
    }
  }

  TableHeader = () => {
    let header = [
      { data: '결재순서', textAlign: 'left' },
      { data: 'ID', textAlign: 'left' },
      { data: '이름', textAlign: 'left' },
      { data: '직책', textAlign: 'left' },
      { data: '상태', textAlign: 'left' },
      { data: '사용자 타입', textAlign: 'left' },
      { data: '결재 상태', textAlign: 'center' }
    ];
    header = cm.tableHeaderList(header, 3, false, 'default', null, true);
    let dom = (
      <Table.Header>
        <Table.Row>
          {header.map((item, idx) => (
            <ScTableHeacerCell key={idx}>{item.data}</ScTableHeacerCell>
          ))}
          <ScTableHeacerCell></ScTableHeacerCell>
        </Table.Row>
      </Table.Header>
    );
    return dom;
  };

  TableBody = async (list) => {
    if (list) {
      await this.setState({
        tempStepList: this.state.tempStepList.concat(list)
      });
    }
  };

  ModalClose = () => {
    this.setState({
      modal: update(this.state.modal, { open: { $set: false } })
    });
  };

  // 사용자 추가
  StepUserAdd = (step) => {
    this.setState({
      modal: update(this.state.modal, { open: { $set: true } }),
      step
    });
  };

  // 사용자 삭제
  StepUserDel = async (step, index) => {
    const { tempStepList } = this.state;
    const userInfosLength = tempStepList[step - 1].userInfos.length;

    if (step !== 1 && userInfosLength === 1) {
      await this.setState({
        tempStepList: update(this.state.tempStepList, {
          $splice: [[step - 1, 1]]
        })
      });
      if (tempStepList[step]) {
        this.state.tempStepList.forEach((item, idx) => {
          this.setState({
            tempStepList: update(this.state.tempStepList, {
              [idx]: {
                step: { $set: idx + 1 }
              }
            })
          });
        });
      }
    } else {
      this.setState({
        tempStepList: update(this.state.tempStepList, {
          [step - 1]: {
            userInfos: { $splice: [[index, 1]] }
          }
        })
      });
    }
  };
  // modal 완료 후 action
  ModalAction = async (modalResult) => {
    const { tempStepList, step } = this.state;
    const checkedUser = [];
    modalResult.forEach((item) => {
      checkedUser.push({
        userId: item.id,
        userName: item.name,
        signId: item.signid,
        orgCode: item.orgCode,
        rankPosition: item.rankPosition,
        status: item.status.code,
        grade: item.grade.code,
        dormant: item.dormant
      });
    });
    const userInfos = this.state.tempStepList[step - 1].userInfos.concat(checkedUser);
    const result = cm.removeDuplicates(userInfos, 'userId');
    this.setState({
      tempStepList: update(this.state.tempStepList, {
        [step - 1]: {
          userInfos: { $set: result }
        }
      })
    });
  };

  // 단계 추가
  StepAdd = () => {
    const { tempStepList } = this.state;
    const stepNum = tempStepList.length;
    const approveSteps = [
      {
        step: stepNum + 1,
        userInfos: []
      }
    ];
    this.setState({
      tempStepList: this.state.tempStepList.concat(approveSteps)
    });
  };

  // 변경 취소
  CancelAction = () => {
    const { approvalStepList } = this.props;
    if (approvalStepList && approvalStepList.data) {
      const { approveSteps } = approvalStepList.data;
      this.setState({
        tempStepList: approveSteps,
        statusFlag: false
      });
    }
  };

  SuccessModal = () => {};

  // 변경 적용
  SuccessAction = async () => {
    const { tempStepList } = this.state;
    const { usageAPI, groupIdx, loadingBarState } = this.props;
    // const userInfosLength = tempStepList[0].userInfos.length;
    if (tempStepList.length === 0 || tempStepList[0].userInfos.length === 0) {
      toastr('top-right', 'warning', '결재순서 1 담당자를 지정해주세요.');
      return;
    }
    const index = [];
    tempStepList.forEach((item, idx) => {
      if (item.userInfos.length === 0) {
        index.push(idx);
        this.setState({
          tempStepList: update(this.state.tempStepList, {
            $splice: [[idx, tempStepList.length - idx]]
          })
        });
        return;
      }
    });
    try {
      const approvalSteps = tempStepList;
      for (var i = 0; i < approvalSteps.length; i++) {
        const item = approvalSteps[i];
        if (item.userInfos.length === 0) {
          approvalSteps.splice(i, approvalSteps.length - i);
          break;
        }
      }

      const params = { approvalSteps };
      await usageAPI.approvalSetMod(groupIdx, params);
      await usageAPI.BillGroupList();

      loadingBarState(true);
      this.setState({
        render: Math.random(),
        statusFlag: false
      });
      setTimeout(() => {
        loadingBarState(false);
        toastr('top-right', 'success', '변경 되었습니다.');
      }, 1000);
    } catch (e) {
      const response = e.response;
      if (response) {
        toastr('top-right', 'error', response.data.message);
      }
      console.log('###### staffSel error : ', e);
    }
  };

  // 변경적용 전 상태 체크
  invoicedStatusCheck = () => {
    const { tempStepList } = this.state;
    const errors = [];

    tempStepList.forEach((item) => {
      const userInfosArr = item.userInfos;

      userInfosArr.forEach((userItem) => {
        const userApprovalStatus = cm.invoicedApprovalStatus(userItem.status, userItem.grade, userItem.isDormant);
        if (!userApprovalStatus.status) {
          errors.push(userApprovalStatus);
        }
      });
    });

    if (errors.length <= 0) {
      // 통과
      this.setState({ statusFlag: true });
    } else {
      errors.sort((a, b) => {
        return a['msgType'] - b['msgType'];
      });
      // 에러, 에러가 여러개인 경우 맨 처음 에러 노출
      const errorFirst = errors[0];
      if (errorFirst.msgType === 1) {
        alert(errorFirst.msg);
        this.setState({ statusFlag: false });
      } else if (errorFirst.msgType === 2) {
        if (!confirm(errorFirst.msg)) {
          this.setState({ statusFlag: false });
        } else {
          this.setState({ statusFlag: true });
        }
      }
    }
  };

  render() {
    const { groupName } = this.props;
    const { tempStepList, modal, render } = this.state;
    const depth = storage.get('depth');
    return (
      <ScContent className="approvalStep">
        <ScHeader className="title-invoice">청구서 상세정보</ScHeader>
        <ScGrid>
          <Grid.Row>
            <Grid.Column>
              <Header as="h4">
                {groupName}
                <ScTextGroup>
                  <ScText>* 결재순서는 1단계부터 제한 없이 생성할 수 있습니다.</ScText>
                  <ScText>
                    * 같은 결재순서에 여러 명의 사용자를 지정할 수 있으며, 그 중 한 명이 결재하면 다음 단계로 결재순서가
                    이동합니다.
                  </ScText>
                  <ScText>* 변경한 결재라인은 다음 청구서부터 적용됩니다.</ScText>
                </ScTextGroup>
              </Header>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <ScTable structured singleLine>
                {this.TableHeader()}
                <Table.Body>
                  {tempStepList.length > 0 ? (
                    tempStepList.map((row) => {
                      let dom =
                        row.userInfos.length > 0
                          ? row.userInfos.map((item, idx) => {
                              const span = idx === 0 ? row.userInfos.length + 1 : 0;
                              let divisionNavi = cm.divisionNavi(item.orgCode, true);
                              if (divisionNavi) {
                                divisionNavi = divisionNavi.split('>');
                              }
                              const divisions = [];
                              for (let i = 1; i <= depth; i++) {
                                let divisionName = '';
                                if (divisionNavi && divisionNavi[i - 1]) {
                                  divisionName = divisionNavi[i - 1];
                                }
                                divisions.push(<Table.Cell key={`division${i}`}>{divisionName}</Table.Cell>);
                              }
                              const userStatus = cm.statusTypeNameV2(item.status, item.isDormant);
                              const userGrade = cm.gradeTypeNameV2(item.grade);
                              return (
                                <Table.Row key={`cell-${idx}`}>
                                  {idx === 0 ? <Table.Cell rowSpan={span}>{row.step}</Table.Cell> : null}
                                  <Table.Cell>{item.signId}</Table.Cell>
                                  <Table.Cell>{item.userName}</Table.Cell>
                                  {divisions.map((item) => item)}
                                  <Table.Cell>{item.rankPosition}</Table.Cell>
                                  <Table.Cell style={{ color: userStatus.fontColor }}>{userStatus.text}</Table.Cell>
                                  <Table.Cell style={{ color: userGrade.fontColor }}>{userGrade.text}</Table.Cell>
                                  <Table.Cell style={{ textAlign: 'left' }} colSpan={2}>
                                    <Button
                                      basic
                                      color="red"
                                      content="삭제"
                                      onClick={(e) => this.StepUserDel(row.step, idx)}
                                    />
                                  </Table.Cell>
                                </Table.Row>
                              );
                            })
                          : [];
                      dom.push(
                        <Table.Row key={`cell`}>
                          {dom.length < 1 ? <Table.Cell>{row.step}</Table.Cell> : null}
                          <Table.Cell colSpan={depth + 8}>
                            <Button
                              basic
                              color="grey"
                              content="사용자 추가하기"
                              onClick={(e) => this.StepUserAdd(row.step)}
                            />
                          </Table.Cell>
                        </Table.Row>
                      );
                      return dom;
                    })
                  ) : (
                    <Table.Row>
                      <Table.Cell style={{ width: 150 }}>1</Table.Cell>
                      <Table.Cell colSpan={depth + 8}>
                        <Button basic color="grey" content="사용자 추가하기" />
                      </Table.Cell>
                    </Table.Row>
                  )}
                  <Table.Row>
                    <ScTableBodyCell colSpan={depth + 8}>
                      <ScUserAddBtn basic color="grey" content="결재 단계 추가하기" onClick={this.StepAdd} />
                    </ScTableBodyCell>
                  </Table.Row>
                </Table.Body>
              </ScTable>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <ScBottomColumn>
              <ScCancelBtn basic onClick={this.CancelAction} style={{ marginRight: 10 }}>
                변경 취소
              </ScCancelBtn>
              <Modal
                trigger={<ScSucessBtn positive content="변경 적용" onClick={this.invoicedStatusCheck} />}
                header="결재라인 변경 적용"
                content="변경한 결재라인은 다음 청구서로부터 적용됩니다. 변경하시겠습니까?"
                actions={[
                  //'변경 취소',
                  { key: 'close', content: '변경 취소', positive: false, onClick: this.CancelAction },
                  { key: 'done', content: '변경 적용', positive: true, onClick: this.SuccessAction }
                ]}
                open={this.state.statusFlag}
              />
            </ScBottomColumn>
          </Grid.Row>
        </ScGrid>
        <CbUserModal modal={modal} />
      </ScContent>
    );
  }
}

const ScContent = styled.div`
  border: 1px solid #dcdcdc;
`;
const ScHeader = styled.h3`
  background-color: #f8f8f8;
  padding: 10px;
  max-height: 40px;
  border-bottom: solid 1px #dcdcdc;
  font-size: 14px;
  border-radius: 0;
  margin-bottom: 0;
`;
const ScGrid = styled(Grid)`
  && {
    height: 100vh;
    overflow: scroll;
    margin: 0;
  }
`;
const ScTextGroup = styled(Header)`
  &&&& {
    margin: 16px 0;
  }
`;
const ScText = styled(Header.Subheader)`
  &&&& {
    line-height: 20px;
    color: black;
  }
`;
const ScTable = styled(Table)`
  &&&& {
    border-collapse: initial;
  }
`;
const ScTableHeacerCell = styled(Table.HeaderCell)`
  /* border-left: none !important;
  border-right: none !important; */
`;
const ScTableBodyCell = styled(Table.Cell)`
  &&&& {
    margin: 0;
    padding: 0;
  }
`;
const ScUserAddBtn = styled(Button)`
  width: 100%;
`;
const ScBottomColumn = styled(Grid.Column)`
  text-align: right;
`;
const ScSucessBtn = styled(Button)`
  width: 200px;
`;
const ScCancelBtn = styled(Button)`
  width: 120px;
`;

BillApprovalStep = connect(
  (state) => ({
    approvalStepList: state.usage.approvalStepList
    // approvalStepResult: state.usage.approvalStepMod
  }),
  (dispatch) => ({
    usageAPI: bindActionCreators(
      {
        approvalSetMod: usg_action.BillApprovalStepMod,
        BillGroupList: usg_action.BillGroupList
      },
      dispatch
    )
  })
)(BillApprovalStep);

export default BillApprovalStep;
